import {
  INTERNAL_SERVER_ERROR,
  PERIOD_NOT_VALID_ERROR,
  TYPE_NOT_VALID_ERROR,
  SCHEDULE_RECURRING_WEEK_DAYS_NOT_VALID_ERROR,
  SCHEDULE_RECURRING_FREQUENCY_NOT_VALID_ERROR,
  TIME_ZONE_NOT_VALID_ERROR,
  SCHEDULE_RECURRING_TYPE_NOT_VALID_ERROR,
  OCCURRENCE_NOT_FOUND_ERROR,
  PERIOD_OVERLAP_ERROR,
} from '../../utils/constants'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import {
  ADD_TO_SCHEDULE,
  EDIT_SCHEDULE,
  GET_CURRENT_SCHEDULE,
  GET_SCHEDULE_BY_ID,
  GET_APPOINTMENT,
  GET_PATIENT,
  GET_CURRENT_SCHEDULE_NO_LOAD,
  GET_APPOINTMENT_NO_LOAD,
  GET_PATIENT_NO_LOAD,
  SET_IS_SUCCESS_SCHEDULE_EDIT,
  SET_LOADING,
  RESET_SCHEDULE_RECURRING_INFO,
  GET_CURRENT_SCHEDULE_SUCCESS,
  SET_UPDATE_SCHEDULE_RANGE,
  SET_IS_APPOINTMENT_POPUP_SHOWN,
  GET_APPOINTMENT_SUCCESS,
  GET_PATIENT_SUCCESS,
  GET_SCHEDULE_BY_ID_SUCCESS,
  SET_ERROR,
  ADD_TO_SCHEDULE_ERROR,
  GET_SCHEDULE_BY_ID_ERROR,
  EDIT_SCHEDULE_ERROR,
  GET_APPOINTMENT_ERROR,
  GET_CURRENT_SCHEDULE_ERROR,
  GET_PATIENT_ERROR,
  UPDATE_SCHEDULE,
  GET_VISIT_TYPE_GROUPS,
  GET_VISIT_TYPE_GROUPS_SUCCESS,
  GET_VISIT_TYPE_GROUPS_ERROR,
} from './CalendarConstants'

const initialState = {
  loading: false,
  error: '',
  schedule: [],
  pnbSchedule: [],
  visitsSchedule: [],
  visitTypeGroups: [],
  scheduleInfoFrom: '',
  scheduleInfoTo: '',
  defaultServerErrorMessage: '',
  AppointmentInfo: {},
  isAppointmentPopUpInfoVisible: false,
  editScheduleSuccess: false,
  scheduleInfoRecurring: null,
  scheduleInfoTreatmentCenter: null,
  updateScheduleRange: null,
  recurringBaseTimeZone: null,
}

export const calendarPageReducer = (state = initialState, action = {}) => {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case ADD_TO_SCHEDULE:
    case EDIT_SCHEDULE:
    case GET_CURRENT_SCHEDULE:
    case GET_SCHEDULE_BY_ID:
    case GET_APPOINTMENT:
    case GET_PATIENT:
    case GET_VISIT_TYPE_GROUPS:
      return {
        ...state,
        loading: true,
      }
    case GET_CURRENT_SCHEDULE_NO_LOAD:
    case GET_APPOINTMENT_NO_LOAD:
    case GET_PATIENT_NO_LOAD:
      return {
        ...state,
      }
    case SET_IS_SUCCESS_SCHEDULE_EDIT:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        editScheduleSuccess: action.payload,
      }
    case SET_LOADING:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        loading: action.payload,
      }
    case RESET_SCHEDULE_RECURRING_INFO:
      return {
        ...state,
        scheduleInfoRecurring: null,
      }

    case GET_VISIT_TYPE_GROUPS_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        visitTypeGroups: action.payload,
        loading: false,
      }
    case GET_CURRENT_SCHEDULE_SUCCESS:
    case UPDATE_SCHEDULE:
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        [action.extraData.tabId]: {
          // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
          ...state?.[action.extraData.tabId],
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          schedule: action.payload.Availability,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          pnbSchedule: action.payload.Unavailability,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          visitsSchedule: action.payload.Visits,
        },
      }
    case SET_UPDATE_SCHEDULE_RANGE:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        updateScheduleRange: action.payload,
      }
    case SET_IS_APPOINTMENT_POPUP_SHOWN:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      switch (action.payload) {
        case true:
          return {
            ...state,
            isAppointmentPopUpInfoVisible: true,
          }
        case false:
          return {
            ...state,
            isAppointmentPopUpInfoVisible: false,
            AppointmentInfo: {},
          }
        default: {
          return state
        }
      }
    case GET_APPOINTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        AppointmentInfo:
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.extraData.shouldShowLoading ? action.payload : { ...state.AppointmentInfo, ...action.payload },
      }
    case GET_PATIENT_SUCCESS:
      return {
        ...state,
        isAppointmentPopUpInfoVisible: true,
        loading: false,
        AppointmentInfo: {
          ...state.AppointmentInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          Patient: { PatientId: state.AppointmentInfo.PatientId, ...action.payload },
        },
      }
    case GET_SCHEDULE_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        scheduleInfoFrom: action.payload.FromDateTime,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        scheduleInfoTo: action.payload.ToDateTime,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        scheduleInfoRecurring: action.payload.RecurringSettings,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        scheduleInfoTreatmentCenter: action.payload.TreatmentCenter ?? null,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        recurringBaseTimeZone: action.payload.TimeZone,
      }

    case SET_ERROR:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode) {
        return {
          ...state,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          error: getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, '', action.payload.extra),
          defaultServerErrorMessage: '',
        }
      }
      return {
        ...state,
        error: '',
        defaultServerErrorMessage: '',
      }
    case ADD_TO_SCHEDULE_ERROR:
    case GET_SCHEDULE_BY_ID_ERROR:
    case EDIT_SCHEDULE_ERROR:
    case GET_APPOINTMENT_ERROR:
    case GET_CURRENT_SCHEDULE_ERROR:
    case GET_PATIENT_ERROR:
    case GET_VISIT_TYPE_GROUPS_ERROR: {
      let message = ''
      // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
      let defaultServerErrorMessage = ''
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
          : ''
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        defaultServerErrorMessage = action.payload.UserFriendlyErrorCode ? action.payload : ''
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        switch (action.payload.ErrorCode) {
          case PERIOD_NOT_VALID_ERROR:
            message = getUserFriendlyErrorMessage(errorCodes.REPEAT_TIME_AFTER_END)
            break
          case TYPE_NOT_VALID_ERROR:
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'schedule type')
            break
          case SCHEDULE_RECURRING_WEEK_DAYS_NOT_VALID_ERROR:
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'weekday selected')
            break
          case SCHEDULE_RECURRING_FREQUENCY_NOT_VALID_ERROR:
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'frequency type')
            break
          case TIME_ZONE_NOT_VALID_ERROR:
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'Timezone')
            break
          case SCHEDULE_RECURRING_TYPE_NOT_VALID_ERROR:
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'recurring type')
            break
          case OCCURRENCE_NOT_FOUND_ERROR:
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'schedule')
            break
          case PERIOD_OVERLAP_ERROR:
            message = getUserFriendlyErrorMessage(
              errorCodes.OVERLAPPING_SCHEDULE,
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              null,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              action.extraData?.visitType === 'availability' ? 'availability' : 'prevent new booking',
            )
            break
          case INTERNAL_SERVER_ERROR:
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            break
          default:
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            defaultServerErrorMessage = action.payload
            break
        }
      }
      return {
        ...state,
        error: message,
        loading: false,
        defaultServerErrorMessage: '',
      }
    }
    default: {
      return state
    }
  }
}
